var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"#24916d","small":"","dark":"","target":"_blank","href":_vm.appointment.trueMeetingURL}},[_c('v-icon',{staticClass:"mr-4",attrs:{"size":"18","left":""}},[_vm._v("fa fa-video")]),_vm._v(" "+_vm._s(_vm.$t("appointment.startconversation"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }